import { render, staticRenderFns } from "./InvitationsPage.vue?vue&type=template&id=7f1bd436&scoped=true"
import script from "./InvitationsPage.vue?vue&type=script&lang=js"
export * from "./InvitationsPage.vue?vue&type=script&lang=js"
import style0 from "./InvitationsPage.vue?vue&type=style&index=0&id=7f1bd436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1bd436",
  null
  
)

export default component.exports